import actions from './actions';

const initState = {
	dataReadAloud: [],
	readAloudDetail: null,
	totalItems: 0,
	loading: false,
};

export default function readAloudReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_READ_ALOUD:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_READ_ALOUD_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataReadAloud: res, totalItems, loading: false };

		case actions.GET_READ_ALOUD_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_READ_ALOUD_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, readAloudDetail: res, loading: false };
		}

		case actions.SPEAKING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
